import { userService } from 'services'
import useSWR, { SWRConfiguration } from 'swr'
import SWR_KEY from './constant'

export const useGetMe = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.GET_ME, userService.getMe, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useNotification = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.NOTIFICATION, userService.getNotification, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useReferral = (id: string | number, configs?: SWRConfiguration) => {
	return useSWR(id ? [SWR_KEY.REFERRAL, id] : null, userService.getReferral, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetCheckInList = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.CHECK_IN_LIST, userService.getList, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetCheckedIn = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.CHECKED_IN, userService.getCheckedIn, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetMerchantList = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.MERCHANT_LIST, userService.getList, {
		revalidateOnFocus: false,
		...configs
	})
}